import SpriteSymbol from "../../.yarn/cache/svg-baker-runtime-npm-1.4.7-fbb2e3215b-925379c771.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../.yarn/cache/svg-sprite-loader-npm-6.0.11-0d03c2400c-ddbd5ea43d.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"logout\"><path d=\"M45.1 146.9C17 118.8 17 73.2 45.1 45.1s73.8-28.1 101.8 0l5.7-5.7c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1C55 168.2 75.5 176 96 176s41-7.8 56.6-23.4l-5.7-5.7c-28.1 28.1-73.7 28.1-101.8 0z\" /><path d=\"M142.8 126.8L173.7 96l-30.9-30.8-5.6 5.6L158.3 92H104v8h54.3l-21.1 21.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol